import React from "react"
import {cloudOutline, cloudSharp} from "ionicons/icons"

import TypeIcon from "./TypeIcon"

interface props {
    link?: string
    size?: "small" | "default" | "large"
    slot?: string
    text?: string
}

const IconDataSource: React.FC<props> = ({ link, size, slot, text }) => {

    return <TypeIcon
        backgroundColor={'lightSteelBlue'}
        link={link}
        ios={cloudOutline}
        md={cloudSharp}
        size={size}
        slot={slot}
        text={text}
    />

}

export default IconDataSource